/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
    apiKey: process.env.MIX_BUGSNAG_API_KEY,
    plugins: [
        new BugsnagPluginVue(Vue)
    ],
    releaseStage: process.env.NODE_ENV,
    user: {
        id: BugsnagUser.id,
        email: null,
        name: BugsnagUser.name,
    },
})

Bugsnag.addMetadata('user', 'url', BugsnagUser.url)

import Buefy from 'buefy'
import Vuex from 'vuex'
import VueTextareaAutosize from 'vue-textarea-autosize'
import router from './router'
import VueI18n from 'vue-i18n'
import VeeValidate, { Validator } from 'vee-validate';
import qs from 'qs'
import VueChartkick from 'vue-chartkick'
import VueVisible from 'vue-visible'
import VueCookies from 'vue-cookies'
import VueObserveVisibility from 'vue-observe-visibility'

import locale from './locale/ru'
import ru from 'vee-validate/dist/locale/ru';

require('./components');

require('./directives');

/**
 * Load page-specific (view) components
 */
import views from './views'
_.each(
    views,
    (route) => {
        let name = _.split(route, '.');
        let element = _.join(_.concat(name, ['view']), '-');
        let path = _.join(
            _.concat(
                _.dropRight(name),
                [_.upperFirst(_.camelCase(_.last(name)))]
            ), '/'
        ) + '.vue';
        Vue.component(element, require('./components/views/' + path));
    }
);

/**
 * Load form components
 */
import forms from './forms'

_.each(
    forms.models,
    (model) => {
        let file = _.upperFirst(_.camelCase(model)) + '.vue';
        let name = _.kebabCase(model) + '-model-form';
        Vue.component(name, require(`./components/forms/models/${file}`));
    }
);

Vue.use(VueCookies)
Vue.use(VueVisible);
Vue.use(VueTextareaAutosize)
Vue.use(VueChartkick)
Vue.use(Buefy)
Vue.use(Vuex)
Vue.use(VueI18n)
Validator.localize('ru', _.merge(ru, locale.validation))
Vue.use(VeeValidate, {
    locale: 'ru',
    dictionary: {
        ru: { messages: locale.messages }
    },
    classes: true,
    classNames: {
        touched: 'touched', // the control has been blurred
        untouched: 'untouched', // the control hasn't been blurred
        valid: 'valid', // model is valid
        invalid: 'is-danger', // model is invalid
        pristine: 'pristine', // control has not been interacted with
        dirty: 'dirty' // control has been interacted with
    },
})
Vue.use(require('vue-shortkey'))
Vue.use(VueObserveVisibility)

const moment = require('moment-timezone')
const momentDurationFormatSetup = require("moment-duration-format")
momentDurationFormatSetup(moment)
require('moment/locale/ru')
moment.updateLocale('ru', locale.moment)

if (window.DefaultTimezone != undefined) {
    moment.tz.setDefault(window.DefaultTimezone);
}

Vue.use(require('vue-moment'), moment)

const messages = {
    ru: locale.messages
}

const i18n = new VueI18n({
    locale: 'ru',
    messages,
})

import storeOptions from './store'

const store = new Vuex.Store(storeOptions)

Object.defineProperty(Vue.prototype, '$_', { value: _ });
Object.defineProperty(Vue.prototype, '$qs', { value: qs });
Object.defineProperty(Vue.prototype, '$bugsnag', { value: Bugsnag });

require('./user')
require('./jwt')

require('./helpers')
require('./abilities')

const app = new Vue({
    el: '#app',
    store,
    router,
    i18n,
    methods: {
        print() {
            window.print()
        }
    }
});

export default app



// WEBPACK FOOTER //
// ./resources/assets/js/app.js